export class ParticipanteAnotacao{
    public ProcessoId: number;
    public Anotacao: string;
    public UsuarioUltimaAlteracaoNome: string;
    public DataUltimaAlteracao: string;
    public UsuarioCriacaoNome: string;
    public DataCriacao: string;
}